import { PLATFORM_LIMITS } from '../../constants/platformCompliance';

const TwitterSettingsPanel = ({ settings, onChange, capabilities, content }) => {
  const text = settings.tweetTextOverride ?? buildTweetText(content);
  const charCount = text.length;
  const limit = PLATFORM_LIMITS.TWITTER.maxChars;
  const isOver = charCount > limit;

  return (
    <div className="space-y-4">
      {/* Protected Account Warning */}
      {capabilities?.protectedAccount && (
        <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-lg text-xs text-amber-800 dark:text-amber-200">
          This is a protected account. Tweets will only be visible to approved followers.
        </div>
      )}

      {/* Tweet Text Editor */}
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="label mb-0">Tweet Text</label>
          <span className={`text-xs ${isOver ? 'text-red-500 font-medium' : 'text-gray-500'}`}>
            {charCount} / {limit}
          </span>
        </div>
        <textarea
          className={`input w-full h-24 resize-none ${isOver ? 'border-red-400' : ''}`}
          value={text}
          onChange={e => onChange({ ...settings, tweetTextOverride: e.target.value })}
          placeholder="What's happening?"
          maxLength={limit + 50}
        />
        {isOver && (
          <p className="text-xs text-red-500 mt-1">Tweet exceeds {limit} character limit</p>
        )}
      </div>

      {/* Tweet Preview */}
      <div className="p-4 border border-gray-200 dark:border-dark-700 rounded-xl">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-dark-600 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1">
              <span className="font-bold text-sm text-gray-900 dark:text-white">
                {capabilities?.platformUsername || 'You'}
              </span>
              <span className="text-xs text-gray-500">@{capabilities?.platformUsername || 'user'}</span>
            </div>
            <p className="text-sm text-gray-900 dark:text-gray-100 mt-1 whitespace-pre-wrap break-words">
              {text || 'Your tweet will appear here...'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

function buildTweetText(content) {
  const parts = [content?.title, content?.description, content?.hashtags].filter(Boolean);
  const full = parts.join('\n\n');
  return full.length > 280 ? full.substring(0, 279) + '\u2026' : full;
}

export default TwitterSettingsPanel;
